import React, { memo } from 'react';

import { Route, Routes } from 'react-router-dom';

import { FilterRouter } from 'components/FilterView';
import { DataClassifierTable } from 'containers/Setup/DataConfiguration/Components/DataClassifier/DataClassifierTable';
import { AddDataClassifier } from 'containers/Setup/DataConfiguration/Components/DataClassifier/DataClassifierWizard/AddDataClassifier';
import { useInjector } from 'utils/inject';

import { dataClassificationSaga } from './saga';
import { sliceKey, reducer } from './slice';

export const DataConfiguration = memo(() => {
  useInjector(sliceKey, reducer, dataClassificationSaga);

  return (
    <Routes>
      <Route element={<FilterRouter path="/setup/data/add/:type" />}>
        <Route path="add/:type" element={<AddDataClassifier />} />
      </Route>
      <Route element={<FilterRouter path="/setup/data" />}>
        <Route index element={<DataClassifierTable />} />
      </Route>
    </Routes>
  );
});
